const DEBOUNCE_TIME = 500;

export { DEBOUNCE_TIME };
